import React, {useState} from 'react';
import {BrowserRouter, Link as RouterLink, Routes, Route, useLocation} from "react-router-dom";
import Page from './page';
import Link from './Link';
import Highlight from "./Highlight";
import {hoowy} from "../../config/config";
import {publicBuildUrl} from "../../config/config";
import Lichaam from "./content/Lichaam";
import Ogen from "./content/Ogen";
import Vleugels from "./content/Vleugels";
import Snavel from "./content/Snavel";
import Buik from "./content/Buik";
import Pootjes from "./content/Pootjes";
import SnavelEmoties from "./content/SnavelEmoties";
import SnavelDilemmas from "./content/SnavelDilemmas";
import SnavelIngredienten from "./content/SnavelIngredienten";
import LichaamShakenBabySyndroom from "./content/LichaamShakenBabySyndroom";
import LichaamMunchausenByProxySyndroom from "./content/LichaamMunchausenByProxySyndroom";
import LichaamMeisjesBesnijdenis from "./content/LichaamMeisjesBesnijdenis";
import OgenSignalen412 from "./content/OgenSignalen412";
import OgenSignalen1218 from "./content/OgenSignalen1218";
import OgenSpiekkaart from "./content/OgenSpiekkaart";
import OgenRisicoFactoren from "./content/OgenRisicoFactoren";

const Hoowy = () => {
    const [hover, setHover] = useState('');

    const handleHover = (item) => {
        setHover(item)
    }

    return (
        <Page title={'Hoowy'}>
            <BrowserRouter>
                <div style={styles.container}>
                    <div className={'bodyContainer'} style={{
                        width: 'min(80vw)',
                        paddingLeft: 0,
                        paddingRight: 0,
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}>
                            <h1 className={'large'}>
                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <div>Kennisdatabank</div>
                                    <div>
                                        <img src={'https://care-free.app/wp-content/uploads/2024/03/Logo_OeHoe_2024.png'} style={{marginLeft: '15px', marginTop: '15px', height: '100px'}} />
                                    </div>
                                </div>
                            </h1>
                        </div>
                        <div style={{
                            display: 'flex',
                            border: '0px solid black',
                        }}>
                            <div className={'bodyContainerColumn'} style={styles.row}>
                                <div style={{
                                    marginTop: '50px',
                                    border: '0px solid green'
                                }}>
                                    {hoowy.map(({item, title}, index) => <Link key={index} onHover={handleHover}
                                                                               selected={hover === item} title={title}
                                                                               item={item}/>)}
                                </div>
                                <Routes>
                                    <Route path={'/lichaam'} element={<Lichaam/>}/>
                                    <Route path={'/lichaam-shakenbabysyndroom'} element={<LichaamShakenBabySyndroom/>}/>
                                    <Route path={'/lichaam-mynchausenbyproxysyndroom'}
                                           element={<LichaamMunchausenByProxySyndroom/>}/>
                                    <Route path={'/lichaam-meisjesbesnijdenis'} element={<LichaamMeisjesBesnijdenis/>}/>
                                    <Route path={'/ogen'} element={<Ogen/>}/>
                                    <Route path={'/ogen-signalen-4-12'} element={<OgenSignalen412/>}/>
                                    <Route path={'/ogen-signalen-12-18'} element={<OgenSignalen1218/>}/>
                                    <Route path={'/ogen-spiekkaart'} element={<OgenSpiekkaart/>}/>
                                    <Route path={'/ogen-risicofactoren'} element={<OgenRisicoFactoren/>}/>
                                    <Route path={'/vleugels'} element={<Vleugels/>}/>
                                    <Route path={'/snavel'} element={<Snavel/>}/>
                                    <Route path={'/snavel-emoties'} element={<SnavelEmoties/>}/>
                                    <Route path={'/snavel-dilemmas'} element={<SnavelDilemmas/>}/>
                                    <Route path={'/snavel-ingredienten'} element={<SnavelIngredienten/>}/>
                                    <Route path={'/buik'} element={<Buik/>}/>
                                    <Route path={'/pootjes'} element={<Pootjes/>}/>
                                </Routes>
                            </div>
                            <div className={'bodyContainerColumn'} style={{...styles.row, position: 'relative'}}>
                                <div style={{
                                    cursor: 'pointer',
                                    position: 'relative',
                                    width: '100%',
                                    border: '0px solid green',
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: "center",
                                    marginTop: '30px',
                                }}>
                                    <img src={publicBuildUrl + 'images/Hoowy' + hover + '.png'} alt={'Hoowy'}
                                         style={{width: '500px', position: 'absolute'}}/>

                                    {hoowy.map(({item, areas}) =>
                                        areas.map((area, index) => <Highlight key={index} onHover={handleHover}
                                                                              item={item} {...area}/>)
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </BrowserRouter>
        </Page>
    );
}

const styles = {
    row: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContents: 'flex-start',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
}

export default Hoowy;
